module.exports = __webpack_public_path__ + "img/logo-white.e570a42e.svg";